import DepositWalletPageContainer from "../../Component/WalletTransfer/DepositWallet/DepositWallet"

const DepositWalletPage = () => {
  return (
    <div className='page-body'>
      <DepositWalletPageContainer />
    </div>
  )
}

export default DepositWalletPage